import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Tabs } from 'antd';
import Taxes from './Taxes';
import TdsTcs from './TdsTcs';
import './style.scss';

const { TabPane } = Tabs;

/**
 *
 */
class Gst extends Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {
      currentTab: '/setup-taxes',
    };
  }

  static getDerivedStateFromProps(props, state) {
    const { location } = props;
    const key = new URLSearchParams(location.search).get('subTab');
    return {
      ...state,
      currentTab: key || '/setup-taxes',
    };
  }

  /**
   *
   * @return {JSX.Element}
   */
  render() {
    const { currentTab } = this.state;
    const { history, user, tab } = this.props;
    return (
      <Fragment>
        <div className="gst__wrapper">
          <Tabs
            activeKey={currentTab}
            onChange={(key) => {
              this.setState({ currentTab: key });
              history.push(`?tab=${tab}&subTab=${key}`);
            }}
            mode="horizontal"
          >
            <TabPane tab="Taxes" key="/setup-taxes" />
            <TabPane tab="Tax Group" key="/setup-tax-groups" />
            {user?.tenant_info?.global_config?.settings?.enable_tds_tcs && (window.innerWidth > 425) && (user?.tenant_info?.country_code === 'IN') && <TabPane tab="TDS/TCS" key="/setup-tds" />}
          </Tabs>
          <div className="gst__body">
            {currentTab === '/setup-taxes' && <Taxes isGroup={false} />}
            {user?.tenant_info?.global_config?.settings?.enable_tds_tcs && user?.tenant_info?.country_code === 'IN' && currentTab === '/setup-tds' && <TdsTcs />}
            {currentTab === '/setup-tax-groups' && <Taxes isGroup={true} />}
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = ({
  UserReducers,
}) => ({
  user: UserReducers.user,
});

const mapDispatchToProps = () => ({
});

Gst.propTypes = {
  location: PropTypes.any,
  user: PropTypes.any,
  tab: PropTypes.any,
  history: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Gst));
